<template>
  <v-container fluid>
    <Navbar
      :hasDrawer="true"
      :title="`Clientes (${clientes.length})`"
    >
      <template slot="actions">
        <v-btn
          icon
          :loading="loading"
          @click="insertClientesAPI"
        ><v-icon>mdi-database-sync</v-icon>
        </v-btn>
        <v-btn :loading="loading" icon @click="getClientesAPI">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon @click="searchBox = !searchBox">
          <v-icon>{{ iconSearch }}</v-icon>
        </v-btn>
      </template>
    </Navbar>
    <v-row v-if="searchBox">
      <v-col cols="12" class="pt-0">
        <SearchBox
          id="searchBox"
          @search="filters.search = $event"
        />
      </v-col>
    </v-row>
    <ListClientes
      :filters="filters"
    />
    <p v-if="error" class="caption text-center font-weight-bold red--text">{{ error }}</p>
    <!-- Button Create Cliente -->
    <v-fab-transition>
      <v-btn
        fixed
        fab
        dark
        bottom
        right
        color="primary"
        class="mb-12"
        @click="createCliente({ idColaborador })"
      ><v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListClientes from '@/components/clientes/ListClientes';
import SearchBox from '@/components/shared/SearchBox';

export default {
  name: 'Clientes',
  data: () => ({
    searchBox: false,
    loading: false,
    error: '',
    filters: {
      order: 'nome_fantasia',
      search: '',
      status: ['P']
    },
  }),
  components: {
    ListClientes,
    SearchBox
  },
  watch: {
    searchBox(value) {
      if (value) this.$nextTick(() => document.getElementById('searchBox').focus());
      else this.filters.search = '';
    }
  },
  computed: {
    ...mapGetters(['clientes', 'idColaborador']),
    iconSearch() {
      return this.searchBox ? 'mdi-close' : 'mdi-magnify';
    }
  },
  methods: {
    ...mapActions(['fetchClientes', 'fetchClientesAPI', 'createCliente', 'sendClientesAPI']),
    async insertClientesAPI() {
      this.loading = true;
      try {
        await this.sendClientesAPI();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    getClientes() {
      this.loading = true;
      this.fetchClientes()
        .then(() => this.loading = false);
    },
    getClientesAPI() {
      this.loading = true;
      this.fetchClientesAPI()
        .then(() => this.loading = false);
    }
  },
  created() {
    if (!this.clientes.length) this.getClientes();
  }
}
</script>

<style>

</style>